import { RefreshCw } from 'lucide-react'
import { usePresalesDashboardStore } from '../store'

function formatMelbourneTime(isoString: string): string {
  const date = new Date(isoString)
  return date.toLocaleString('en-AU', {
    timeZone: 'Australia/Melbourne',
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
}

export function SyncButton() {
  const { isSyncing, syncFromHubSpot, lastSyncedAt } = usePresalesDashboardStore()

  const handleSync = async () => {
    await syncFromHubSpot()
  }

  const lastSyncLabel = lastSyncedAt
    ? `Last synced: ${formatMelbourneTime(lastSyncedAt)}`
    : 'Never synced'

  return (
    <div className="flex items-center gap-3">
      <span className="text-xs text-[var(--text-muted)]">{lastSyncLabel}</span>
      <button
        onClick={handleSync}
        disabled={isSyncing}
        className={`
          flex items-center gap-2 px-4 py-2 rounded-lg
          bg-[var(--button-primary-bg)] text-[var(--button-primary-text)]
          hover:bg-[var(--button-primary-hover)] transition-colors
          disabled:opacity-50 disabled:cursor-not-allowed
          text-sm font-medium
        `}
      >
        <RefreshCw className={`h-4 w-4 ${isSyncing ? 'animate-spin' : ''}`} />
        {isSyncing ? 'Syncing...' : 'Sync from HubSpot'}
      </button>
    </div>
  )
}
